import { SET_REGIONS, REGIONS_ERROR } from '../types/RegionsTypes';
import { callGetRegions } from '../../services/RegionsService';

export const errorInGetRegions = () => {
  return { type: REGIONS_ERROR };
};

export const setRegions = (regions) => {
  return { type: SET_REGIONS, regions };
};

export const getRegions = () => {
  return async (dispatch) => {
    try {
      const res = await callGetRegions();
      if (res.status !== 200) dispatch(errorInGetRegions());
      else dispatch(setRegions(res.data.children));
    } catch (err) {
      dispatch(errorInGetRegions());
    }
  };
};
